import IPDQueuePage from './IPDQueuePage';

/** Receptionist queue for parallel OIPD / insurance settlement billing. */
export default function IPDOfflineQueuePage() {
  return <IPDQueuePage offlineMode />;
}
